// extracted by mini-css-extract-plugin
export default {"button":"Button_button__lh1wX","lightButton":"Button_lightButton__GwEmH","smallButton":"Button_smallButton__pvRlu"};